module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18023/js/img/valuePropModals/SequencesEmailCommunicator/ValueProp1.svg"